import React, { Component } from 'react';
import { View, Spinner, PageContainer, Loc } from '../UIElements/All.js';
import { Colors, ModalColors } from '../Managers/ThemeManager';

import { replace, restoreHistory, navigateTo } from '../Managers/AppActions';
import { getURLInputs, setCookie, getComponent, getURL } from '../Managers/Utils';
import { getExternalUser, login, LOGIN_ERROR_CODE } from '../Managers/NetworkManager';
import { setReturnURLSession, setLsRetailSession, getReturnURLSession, setSignedURLIfValid } from '../Managers/SessionManager';
var LocalizationManager = require('../Managers/LocalizationManager.js');

export default class Splash extends Component {
	constructor(props) 
	{
		super(props);
		var state = {loadingText:"", urlInputs:getURLInputs()};
		var self =  this;
		LocalizationManager.localizedStringForKey("LOADING_SPINNER", [], (retrievedString)=>
		{
			state.loadingText = retrievedString;
		}); 
		
		this.state = state;
	}

	componentDidMount() {
		const self = this;
		const component = getComponent();
		const urlInputs = getURLInputs();
		setSignedURLIfValid(getURL());
		
		login(getURL(), urlInputs.accountID).then((response, error) => {
			setReturnURLSession(urlInputs.returnURL);
			if (error != null && error.code == LOGIN_ERROR_CODE) {
				navigateTo('/missingSignature', {
					urlInputs:{
						returnURL:getReturnURLSession()
					}
				});
				return;
			} else if (response != null && typeof response.sessionToken !== 'undefined') {
				setLsRetailSession(response.sessionToken);
			}
			if (typeof component !== 'undefined' && component != null) {
				const didRestoreFromCache = restoreHistory(this);
				if (!didRestoreFromCache) {
					replace(self, 'error', {
						title: "ERROR_ALERT_TITLE",
						body: "SOMETHING_WENT_WRONG_ERROR_BODY",
						closeButtonOnly: true,
					});
				}
	
				return;
			} else {
				const urlInputs = getURLInputs();
				setCookie("urlInputs", JSON.stringify(urlInputs), 7);
				this.setState({ urlInputs });
	
				if (typeof urlInputs.customerID !== 'undefined' && urlInputs.customerID > 0) {
					getExternalUser(urlInputs.customerID, urlInputs).then((user, error) => {
						if (error != null) {
							let qrCode = { urlInputs };
	
							if (user != null && typeof user.lsUser !== 'undefined') {
								qrCode.lsUser = {};
								if (typeof user.lsUser.Contact !== 'undefined') {
									qrCode.lsUser.Contact = user.lsUser.Contact;
								}
							}
	
							if (
								user.phoneLocales != null &&
								typeof user.phoneLocales !== 'undefined' &&
								typeof user.phoneLocales.Countries !== 'undefined'
							) {
								qrCode.phoneLocales = user.phoneLocales.Countries;
							}
	
							replace(self, 'CustomerPhoneNumber', qrCode);
						} else {
							const qrCode = {
								userID: user.UserID,
								hash: user.Hash,
								type: "phone",
							};
	
							replace(self, 'customerOptions', {
								qrCode,
								hidePay: true,
								urlInputs,
							});
						}
					});
				} else {
					replace(self, 'error', {
						urlInputs,
						title: "NO_CUSTOMER_ASSIGNED_ERROR_TITLE",
						body: "NO_CUSTOMER_ASSIGNED_ERROR_BODY",
						closeButtonTitle: "BACK_TO_SALE_BUTTON",
						closeButtonOnly: true,
					});
				}
	
				return;
			}
		})
	}	

  render() 
  {
    return (
      <PageContainer style={{backgroundColor:Colors.background1, color:Colors.text1, flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}} urlInputs={this.state.urlInputs}>
      	<View style={{alignSelf:'center'}}>
      	<Spinner color={ModalColors.border} />
      	</View>
      </PageContainer>
    );
  }
}